import styled, { css } from 'styled-components';

export const gallery = css`
  width: 100%;
  padding: 5em 1em 5em 1em;

  @media (max-width: 794px) {
      padding: 3em 1em 3em 1em;
    }
`;

export const white = css`
  background-color: var(--white);
  width: 100%;
  padding: 5em 1em 5em 1em;

  @media (max-width: 794px) {
      padding: 3em 1em 3em 1em;
    }
`;